import { toast } from 'react-toastify';

import moment from 'moment';
import qs from 'querystring';
import { takeLatest, call, put, all } from 'redux-saga/effects';

import { t } from '~/helpers';
import api from '~/services/api';
import history from '~/services/history';

import {
  successInRequest,
  failedRequest,
  successRemove,
  successRequest,
} from './actions';

export function* requestOperacaoPreRecebimentoLista({ payload }) {
  try {
    const { params } = payload;
    const response = yield call(api.get, 'operacaoprerecebimentolistas', {
      params,
      paramsSerializer: (param) => qs.stringify(param),
    });
    const { items, page, pageSize, totalCount, totalPages } = response.data;

    yield put(successInRequest(items, page, pageSize, totalCount, totalPages));
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* deleteOperacaoPreRecebimentoLista({ payload }) {
  try {
    const { prri_nf, params } = payload;

    yield call(api.delete, `operacaoprerecebimentolistas/${prri_nf}`);
    yield put(successRemove({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoexclusao'));
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* store({ payload }) {
  try {
    const { operacaoprerecebimentolista, params } = payload;

    yield call(
      api.post,
      'operacaoprerecebimentolistas',
      operacaoprerecebimentolista
    );
    yield put(successRemove({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoinclusao'));
    history.push('/prerecebimentolista');
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* find({ payload }) {
  try {
    const { prri_nf } = payload;

    const { data } = yield call(
      api.get,
      `operacaoprerecebimentolistas/${prri_nf}`
    );

    const dataMod = {
      ...data,
      datahorainicialmovimentacao: moment(
        data.datahorainicialmovimentacao,
        'DD/MM/YYYY HH:mm:ss',
        true
      ).format('YYYY-MM-DDTHH:mm:ss'),
      datahorafinalmovimentacao: moment(
        data.datahorafinalmovimentacao,
        'DD/MM/YYYY HH:mm:ss',
        true
      ).format('YYYY-MM-DDTHH:mm:ss'),
    };

    yield put(successRequest(dataMod));
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* update({ payload }) {
  try {
    const { operacaoprerecebimentolista, params } = payload;

    yield call(
      api.put,
      'operacaoprerecebimentolistas',
      operacaoprerecebimentolista
    );
    yield put(successRemove({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoalteracao'));
    history.push('/prerecebimentolista');
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* applyedFilters({ payload }) {
  try {
    const { params } = payload;

    const response = yield call(api.get, 'operacaoprerecebimentolistas', {
      params,
      paramsSerializer: (param) => qs.stringify(param),
    });

    const { items, page, pageSize, totalCount, totalPages } = response.data;

    yield put(successInRequest(items, page, pageSize, totalCount, totalPages));
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export default all([
  takeLatest(
    '@operacaoprerecebimentolista/OPERACAOPRERECEBIMENTOLISTA_IN_REQUEST',
    requestOperacaoPreRecebimentoLista
  ),
  takeLatest(
    '@operacaoprerecebimentolista/DELETE_OPERACAOPRERECEBIMENTOLISTA',
    deleteOperacaoPreRecebimentoLista
  ),
  takeLatest(
    '@operacaoprerecebimentolista/SUCCESS_REMOVE',
    requestOperacaoPreRecebimentoLista
  ),
  takeLatest(
    '@operacaoprerecebimentolista/STORE_OPERACAOPRERECEBIMENTOLISTA',
    store
  ),
  takeLatest(
    '@operacaoprerecebimentolista/FIND_OPERACAOPRERECEBIMENTOLISTA',
    find
  ),
  takeLatest(
    '@operacaoprerecebimentolista/UPDATE_OPERACAOPRERECEBIMENTOLISTA',
    update
  ),
  takeLatest('@operacaoprerecebimentolista/RECORD_FILTERING', applyedFilters),
]);
